import { useCallback, useState } from "react";

import type { IntentNodeId, IntentTaxonomyIndex } from "app/pages/sales-intelligence/domain/intent/types/taxonomy";
import type {
    TechnologyNodeId,
    TechnologyTaxonomyIndex,
} from "app/pages/sales-intelligence/domain/technology/types/taxonomy";

import type { SignalEnrichmentFiltersPayload } from "../types/model";
import { buildSignalFiltersPayload } from "../utils/buildSignalFiltersPayload";

type BuildPayloadParams = {
    readonly intentIndex?: IntentTaxonomyIndex;
    readonly technologyIndex?: TechnologyTaxonomyIndex;
};

type DealSignalFilterSelection = {
    readonly intentSelectedIds: readonly IntentNodeId[];
    readonly technologySelectedIds: readonly TechnologyNodeId[];
    readonly setIntentSelectedIds: (ids: readonly IntentNodeId[]) => void;
    readonly setTechnologySelectedIds: (ids: readonly TechnologyNodeId[]) => void;
    readonly buildPayload: (params: BuildPayloadParams) => SignalEnrichmentFiltersPayload | undefined;
};

export const useDealSignalFilterSelection = (): DealSignalFilterSelection => {
    const [intentSelectedIds, setIntentSelectedIds] = useState<readonly IntentNodeId[]>([]);
    const [technologySelectedIds, setTechnologySelectedIds] = useState<readonly TechnologyNodeId[]>([]);

    const buildPayload = useCallback(
        ({ intentIndex, technologyIndex }: BuildPayloadParams) =>
            buildSignalFiltersPayload({
                intent: intentIndex ? { index: intentIndex, ids: intentSelectedIds } : undefined,
                technology: technologyIndex ? { index: technologyIndex, ids: technologySelectedIds } : undefined,
            }),
        [intentSelectedIds, technologySelectedIds],
    );

    return {
        intentSelectedIds,
        technologySelectedIds,
        setIntentSelectedIds,
        setTechnologySelectedIds,
        buildPayload,
    };
};
